// AUTO-GENERATED CODE, DO NOT EDIT!
/* eslint-disable */

import * as Types from '../../../types';

import gql from 'graphql-tag';
import { EventMenuItemEventFragmentDoc } from './EventMenuItem/EventMenuItem.generated-types';
export type SideBarEventFragment = { __typename?: 'Event', UUID: string, name: string, location: string, status: Types.EventStatus, fromDateTime: string, toDateTime: string, proposalCount: number, proposals: Array<{ __typename?: 'Proposal', UUID: string, invitationID: number, status: Types.ProposalStatus }>, invitations?: Array<{ __typename?: 'Invitation', ID: number, declinedAt?: string | null }> | null };

export const SideBarEventFragmentDoc = gql`
    fragment SideBarEvent on Event {
  UUID
  ...EventMenuItemEvent
}
    ${EventMenuItemEventFragmentDoc}`;